import { render } from "./CardsReport.vue?vue&type=template&id=05932634&scoped=true"
import script from "./CardsReport.vue?vue&type=script&lang=js"
export * from "./CardsReport.vue?vue&type=script&lang=js"

import "./CardsReport.vue?vue&type=style&index=0&id=05932634&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05932634"]])

export default __exports__